module.exports = __webpack_public_path__ + "img/goods1.4d8c8f07.jpg";